module.exports = __webpack_public_path__ + "img/winerackdog19.f4367db1.jpg";